{
  "public-appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Neuen Termin buchen",
      "cancel": "Termin stornieren"
    }
  }
}
